
TPS.Videos = {
    videoItemSelector: '.video-modal-cta',
    videoModalSelector: '#video-modal',
    init: function (selector) {
        
        if (selector) {
            TPS.Videos.videoItemSelector += ' ' + selector;
        }
        TPS.Videos.setupVideoModal();
        TPS.Videos.setupBillboardVideo();

    },
    videoCategories: function () {

        jQuery(document).on('click', '.video-categories-nav-heading', function (e) {
            e.preventDefault();

            if (TPS.Util.getScreenWidth() < 1024) {

                var navParent = jQuery(this).parents('.video-categories-nav');
                var isActive = navParent.hasClass('active');
                var isAnimated = navParent.find('ul').is(':animated');
                var icon = jQuery(this).find('.icon');

                if (!isActive && !isAnimated) {
                    navParent.addClass('active');
                    icon.removeClass('ion-ios-arrow-down').addClass('ion-ios-arrow-up');
                } else if (!isAnimated) {
                    navParent.removeClass('active');
                    icon.removeClass('ion-ios-arrow-up').addClass('ion-ios-arrow-down');
                }
            } 

        });

        jQuery(document).on('click', '.video-categories-nav ul li a', function (e) {
            e.preventDefault();
            if(!jQuery(this).hasClass('active')) {
                var catFilter = jQuery(this).attr('data-category-name');
                if (catFilter != 'all' && catFilter != '') {

                    var catFilterSelector = '.cat-' + catFilter;
                    jQuery('.video-item-wrapper').not(catFilterSelector).hide(400);
                    jQuery(catFilterSelector).show(500);

                } else if (catFilter == 'all' || catFilter == '') {

                    jQuery('.video-item-wrapper').show(500);

                }
                jQuery('.video-categories-nav ul li a').removeClass('active');
                jQuery(this).addClass('active');

                if (TPS.Util.getScreenWidth() < 1024) {
                    jQuery('.video-categories-nav').removeClass('active');
                    jQuery('.video-categories-nav .icon').removeClass('ion-ios-arrow-up').addClass('ion-ios-arrow-down');
                }
            }
            
        });



    },
    getIdFromUrl: function (url, delim) {
        return url.substr(url.lastIndexOf(delim) + delim.length, url.length);
    },
    setupVideoModal: function () {

        jQuery(document).on('click', TPS.Videos.videoItemSelector, function (e) {
            e.preventDefault();
            var videoURL = jQuery(this).attr('data-video-url');
            var videoTitle = jQuery(this).attr('data-video-title');
            if (typeof videoURL != undefined && videoURL != '') {
                TPS.Videos.openVideoModal(videoURL, videoTitle);
            }
        });

        jQuery(document).on('closed.zf.reveal', TPS.Videos.videoModalSelector, function (e) {
            TPS.Videos.closeVideoModal();
        });
    },
    videoEmbedUrl: function (url) {
        var delim, s_url;
        if (url) {
            if (url.indexOf('youtu') > -1) {

                delim = 'v=';
                s_url = '//www.youtube.com/embed/' + TPS.Videos.getIdFromYoutubeUrl(url) + '?autoplay=1';

                return s_url;

            } else if (url.indexOf('vimeo') > -1) {

                delim = '/';
                s_url = '//player.vimeo.com/video/' + TPS.Videos.getIdFromVimeoUrl(url) + '?autoplay=1';
                return s_url;

            } else {
                console.log('the video URL is not supported');
                return false;
            }
            
        } else {
            return false;
        }
    },
    videoEmbedCode: function (url, title) {
        if (url) {
            var embedUrl = TPS.Videos.videoEmbedUrl(url);
            var videoElemWrapper = jQuery('<div>').addClass('tps-video-frame-wrapper');
            var videoElem;
            if (embedUrl) {
                
                videoElem = jQuery('<iframe>').attr(
                    {
                        'allowfullscreen': 'true',
                        'title': title,
                        'src': embedUrl
                    }
                );
            } else {

                videoElem = jQuery('<video>').attr({
                    'src': url,
                    'autoplay': 'true',
                    'controls': '',
                    'controlslist': 'nodownload noremoteplayback',
                    'disablePictureInPicture': '',
                    'disableRemotePlayback': ''
                });

            }
            videoElem.addClass('tps-video-frame')
            videoElemWrapper.append(videoElem);

            return videoElemWrapper;
        } else {
            console.log('no video url was provided');
            return false;
        }
    },
    openVideoModal: function (url, title) {
        var videoModal = jQuery(TPS.Videos.videoModalSelector);
        var _t = 'Streamed Video Content';
        if (typeof title != 'undefined') {
            _t = title;
        }

        videoModal.parents('.reveal-overlay').addClass('video-reveal-overlay');

        var videoElem = TPS.Videos.videoEmbedCode(url, _t);
        if (videoElem) {
            videoModal.find('.video-modal-content').append(videoElem);
            videoModal.foundation('open');
        }
    },
    closeVideoModal: function () {
        var videoModal = jQuery(TPS.Videos.videoModalSelector);
        videoModal.find('.video-modal-content').empty();
    },
    setupBillboardVideo: function () {
        var url = jQuery('.landing-page-billboard-video').attr('data-video-url');

        if (url) {
            if (url.indexOf('youtu') > -1) {
                $('.landing-page-billboard-video iframe').attr("src", '//www.youtube.com/embed/' + TPS.Videos.getIdFromYoutubeUrl(url) + '?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&playlist=' + TPS.Videos.getIdFromYoutubeUrl(url) );
            } else if (url.indexOf('vimeo') > -1) {
                var delim = '/';
                $('.landing-page-billboard-video iframe').attr("src", '//player.vimeo.com/video/' + TPS.Videos.getIdFromVimeoUrl(url) + '?background=1&autoplay=1&muted=1&loop=1');
            } else {
                console.log('the video URL is not supported');
            }
        }       
    },
    getIdFromYoutubeUrl: function (url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    },
    getIdFromVimeoUrl: function (url) {
        var regExp = /https?:\/\/(?:www\.)?(?:player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
        var match = url.match(regExp);
        return match ? match[3] : false;
    }
}
